import axios from 'axios';


// const backendUrl = 'http://localhost:21589'
// var backendUrl = 'https://apps.delphus.inf.br:21590' // homologação
// const backendUrl = 'http://192.168.0.194:21590' // homologação
var backendUrl = 'https://celg.delphus.com.br:31590' // produção
if(window.location.origin == 'http://localhost:3000') {
    backendUrl = 'http://localhost:21589'
} else if(window.location.origin == 'https://apps.delphus.inf.br' ){
    backendUrl = 'https://apps.delphus.inf.br:21590'
}


console.log(backendUrl)
console.log(window.location.origin)

const api = axios.create({
    baseURL: backendUrl + `/api/`
});

api.getComboData = async (table, parameter) => {
    return new Promise(async (resolve, reject) => {
        console.log('Searching for parameter ' + parameter)
        await api.get('/' + table + '/combo' + (parameter ? '?' + parameter : '')).then(async r => {
            console.log(r.data, table)
            resolve(r.data)
        })
    })
}

api.getComboDataWhere = async (table, where) => {
    return new Promise(async (resolve, reject) => {
        console.log('/' + table + '/combo' + where)
        await api.get('/' + table + '/combo' + where).then(async r => {
            resolve(r.data)
        })
    })
}

api.getComboDataAsync = async (table, setCombo, parameter) => {
    return new Promise(async (resolve, reject) => {
        console.log('Searching for parameter ' + parameter)
        await api.get('/' + table + '/combo' + (parameter ? '/' + parameter : '')).then(async r => {
            console.log(r.data)
            resolve(setCombo(r.data))
        })
    })
}

api.getAcessos = async (tela, opcao) => {
    return new Promise(async (resolve, reject) => {
        // console.log('Searching for parameter '+tela+' '+opcao)
        let auth = JSON.parse(localStorage['authcelg']);

        await api.get('/grupo_usuarios/permissoes?tela=' + tela + '&pk_usu=' + auth.user + '&acao=' + opcao).then(async r => {
            if (opcao === 'Consulta') {
                try {
                    resolve(r.data[0].Consulta)
                }
                catch { resolve('N') }
            }

            if (opcao === 'Inclusao') {
                try {
                    resolve(r.data[0].Inclusao)
                }
                catch { resolve('N') }
            }

            if (opcao === 'Alteracao') {
                try {
                    resolve(r.data[0].Alteracao)
                }
                catch { resolve('N') }
            }

            if (opcao === 'Exclusao') {
                try {
                    resolve(r.data[0].Exclusao)
                }
                catch { resolve('N') }
            }

            // resolve(r.data)
        })
    })
}


api.getListData = async (table, parameter) => {
    return new Promise(async (resolve, reject) => {
        console.log('Searching for parameter ' + parameter)
        await api.get('/' + table + '/lista' + (parameter ? '/' + parameter : '')).then(async r => {
            console.log(r.data)
            resolve(r.data)
        })
    })
}

api.getImage = async (regName, pk, image) => {
    return new Promise(async (resolve, reject) => {
        if (pk && image) {
            axios.get(backendUrl + '/static/upload/fotos/' + regName + '/' + pk + '/' + image).then(r => {
                resolve(backendUrl + '/static/upload/fotos/' + regName + '/' + pk + '/' + image)
            }).catch(e => resolve(backendUrl + '/static/upload/no-image.jpg'))
        } else resolve(backendUrl + '/static/upload/no-image.jpg')
    })
}

api.getTipoDocumento = async (fk_mdl) => {
    return new Promise(async (resolve, reject) => {
        resolve(await api.getComboData('tipo_documento', fk_mdl))
    })
}

api.noImageUrl = backendUrl + '/static/upload/no-image.jpg'
api.backendUrl = backendUrl

export default api